import dayjs from 'dayjs';

/**
 * The note an invoice starts with: the tenant's default note on an invoice paid
 * in full, with `{date}` replaced by today's date — empty otherwise.
 *
 * One definition for both invoice paths: the client-side dialog
 * (`InvoiceOptionsDialog`, Mode C tenants) and server-side issuance
 * (`IssueInvoiceSection`, Mode A). The second path lost this note entirely when
 * it replaced the first; sharing the rule keeps the two from drifting again.
 */
export const invoiceNotePrefill = (
    defaultNote: string | undefined,
    isPaidInFull: boolean,
    language: string,
): string => {
    if (!isPaidInFull || !defaultNote) return '';
    const dateFormat = language.toLowerCase().startsWith('de') ? 'DD.MM.YYYY' : 'MM/DD/YYYY';
    return defaultNote.replace('{date}', dayjs().format(dateFormat));
};
